export function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export function ctrlVismenu(key) {

    var vismenu = (localStorage.getItem('vismenu') || '').trim();

    if (vismenu == '' && key != 'Z') { //diverso da Z perchè Z è limitante e non abilitante
        return true;
    } else {
        var array = vismenu.split(',');
        for (var i = 0; i < array.length; i++) {
            if (array[i].trim() == key.trim()) {
                return true;
            }
        }
    }

    return false;

}

export function ctrlViscategoria(key) {

    var viscategoria = (localStorage.getItem('viscategoria') || '').trim();

    //console.log("viscategoria: " + viscategoria);

    if (viscategoria == '') {
        return true;
    } else {
        var array = viscategoria.split(',');
        //console.log("viscategoria array: " + JSON.stringify(array));
        for (var i = 0; i < array.length; i++) {
            if (array[i].trim() == key.trim()) {
                //console.log("array: " + array[i].trim() + " - key " + key.trim());
                return true;
            }
        }
    }

    return false;

}